import styles from './Layout.module.css'
import PropTypes from 'prop-types'

export const Header = ({ title, children }) => {
  return (
    <header className={[styles.header].join(' ')}>
      <a href="/">
        <h1 className={[styles.header__title].join(' ')}>
          {title}
        </h1>
      </a>
      {children}
    </header>
  )
}

Header.propTypes = {
  title: PropTypes.string.isRequired,
}

export const Main = ({ children }) => {
  return <main>{children}</main>
}

export const Section = ({ title, children }) => {
  return (
    <section>
      <h2>{title}</h2>
      <hr />
      <div style={{ margin: '2rem 1rem' }}></div>
      {children}
    </section>
  )
}

Section.propTypes = {
  title: PropTypes.string.isRequired,
}

export const Footer = () => {
  return (
    <footer
      style={{ padding: '2rem', textAlign: 'center' }}
    >
      <p>
        This app was designed & created by{' '}
        <a
          rel="noreferrer"
          target="_blank"
          href="https://www.oodri.dev"
        >
          Oodri
        </a>{' '}
        as part of the{' '}
        <a
          rel="noreferrer"
          target="_blank"
          href="https://fullstackopen.com/en/"
        >
          Fullstack Open Course
        </a>{' '}
        offered by the University of Helsinki.
      </p>
      <div
        style={{
          display: 'flex',
          gap: '2rem',
          justifyContent: 'center',
          marginTop: '2rem',
        }}
      >
        <a
          href="http://www.oodri.dev"
          target="_blank"
          rel="noreferrer"
        >
          Website
        </a>
        <a
          href="https://github.com/ElvannAbendroth"
          target="_blank"
          rel="noreferrer"
        >
          Github
        </a>
        <a
          href="https://www.behance.net/elvann"
          target="_blank"
          rel="noreferrer"
        >
          Behance
        </a>
      </div>
    </footer>
  )
}
